<template>
	<div class="videopart">
		<div class="videopart__inner">
		<video 
			ref="video" 
			class="videopart__video" 
			:poster="poster"
			:muted="loop"
			:autoplay="autoplay"
			:controls="false"
			:loop="loop"
			:preload="meta"
			:playsinline="true"
		>
			<source :src="src" type="video/mp4" >
		</video>

		<div v-if="controls">
			<figcaption>
				<div class="video-progress">
					<progress ref="progressbar" value="0" min="0" max="100"></progress>
					<input ref="seek" class="seek"  value="0" min="0" type="range" step="0.1">
					<!-- <div class="seek-tooltip" id="seek-tooltip">{{videoDuration}}</div> -->
				</div>
			</figcaption>

			<div 
				v-on:click="onClickVideo"
				class='video-controls video--meta'
				:class="{active: state === videoStates.PLAYING}">
				<div class="video--meta-items">
					<div class="videopart__caption m-b-sm" v-if="description.length > 0"> {{ description }}</div>

					<div class="video-time" >
						<div v-if="videoDuration">
							<time id="time-elapsed">{{ videoElapsed.minutes }}:{{ videoElapsed.seconds }}</time>
							<span> / </span>
							<time id="duration">{{ videoDuration.minutes }}:{{ videoDuration.seconds }}</time>
						</div>
					</div>

				</div>

				<div class="video-icons">
					<div class='video--icon video--icon-loop' 
						v-if="state === videoStates.END">
						<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
							<circle class="video-icon__bg" cx="16" cy="16" r="15.5" />
							<path class="video-icon__main-fill" fill-rule="evenodd" clip-rule="evenodd" d="M16 11C17.0806 11.0004 18.1321 11.3509 18.9968 11.999C19.8615 12.6471 20.493 13.558 20.7966 14.5951C21.1003 15.6322 21.0597 16.7398 20.6811 17.7519C20.3025 18.764 19.6061 19.6263 18.6963 20.2094C17.7865 20.7926 16.7123 21.0653 15.6345 20.9868C14.5567 20.9082 13.5334 20.4826 12.7178 19.7736C11.9022 19.0647 11.3383 18.1105 11.1105 17.0542C10.8826 15.9978 11.0031 14.8961 11.454 13.914C11.5031 13.7946 11.504 13.6608 11.4567 13.5407C11.4094 13.4206 11.3175 13.3234 11.2002 13.2696C11.0829 13.2157 10.9493 13.2093 10.8273 13.2517C10.7054 13.2941 10.6046 13.382 10.546 13.497C10.005 14.6756 9.86042 15.9977 10.1339 17.2654C10.4074 18.533 11.0843 19.678 12.0631 20.5286C13.0419 21.3793 14.2699 21.89 15.5633 21.9842C16.8567 22.0783 18.1458 21.7509 19.2375 21.0509C20.3292 20.3509 21.1647 19.3161 21.6189 18.1014C22.0731 16.8868 22.1216 15.5576 21.757 14.3131C21.3924 13.0686 20.6344 11.9757 19.5965 11.1982C18.5586 10.4206 17.2968 10.0002 16 10V11Z" />
							<path class="video-icon__main-fill" d="M16 12.4661V8.53409C16 8.48658 15.9865 8.44007 15.961 8.39999C15.9355 8.35991 15.8991 8.32792 15.856 8.30778C15.813 8.28763 15.7652 8.28016 15.718 8.28623C15.6709 8.29231 15.6265 8.31168 15.59 8.34209L13.23 10.3081C13.2019 10.3315 13.1793 10.3609 13.1637 10.3941C13.1482 10.4273 13.1401 10.4635 13.1401 10.5001C13.1401 10.5367 13.1482 10.5729 13.1637 10.6061C13.1793 10.6393 13.2019 10.6686 13.23 10.6921L15.59 12.6581C15.6265 12.6885 15.6709 12.7079 15.718 12.7139C15.7652 12.72 15.813 12.7125 15.856 12.6924C15.8991 12.6723 15.9355 12.6403 15.961 12.6002C15.9865 12.5601 16 12.5136 16 12.4661Z" />
							</svg>
					</div>
					
					<div class='video--icon video--icon-pause' 
							v-if="state === videoStates.PLAYING">
							<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle class="video-icon__bg" cx="16" cy="16" r="15.5" />
								<path d="M14 19L14 13" class="video-icon__main-stroke" stroke-width="2.5" stroke-linecap="round"/>
								<path d="M18 19L18 13" class="video-icon__main-stroke" stroke-width="2.5" stroke-linecap="round"/>
							</svg>
						</div>

					<div class='video--icon video--icon-play' 
						v-if="state === videoStates.PAUSE">
							<svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
								<circle class="video-icon__bg" cx="16" cy="16" r="15.5" />
								<path class="video-icon__main-fill" d="M13.7585 10.4789C14.0708 10.3182 14.4466 10.3455 14.7324 10.5496L21.2949 15.2371C21.5413 15.4131 21.6875 15.6972 21.6875 16C21.6875 16.3028 21.5413 16.5869 21.2949 16.7629L14.7324 21.4504C14.4466 21.6545 14.0708 21.6818 13.7585 21.5211C13.4463 21.3604 13.25 21.0387 13.25 20.6875V11.3125C13.25 10.9613 13.4463 10.6396 13.7585 10.4789Z" />
							</svg>
					</div>
				</div>

			</div>
		</div>
		</div>
	</div>
</template>

<script>
	// import Audiobutton from '@/components/audiobutton/audiobutton';

	let videoStates = {
		PLAYING: 'PLAYING',
		PAUSE: 'PAUSE',
		END: 'END'
	}

export default {
	name: 'videopart',
	props: {
		media: {},
		src:{},
		description: {type: String},
		poster: {},
		controls: {
			type:Boolean,
			default: false
		},
		loop: { type: Boolean, required: false, default: false },
		autoplay: { type: Boolean, required: false, default: false },
		muted: { type: Boolean, required: false, default: true },
		preload: { type: String, required: false, default: "auto" },
	},
	data() {
		return {
			videoStates: videoStates,
			state: videoStates.PAUSE,
			videoDuration: {minutes: 0, seconds: 0},
			videoElapsed: {minutes: 0, seconds: 0}
		}
	},
	mounted: function() {
		if(this.loop) {
			return;
		}

		this.$nextTick(() => {
			this.setupListeners();
		});
	},

	watch: {
	},

	computed: {
		isAudioOn() {
			return true;
		},

		showAudiobutton() {
			return window.innerWidth < 600;
		}
	},

	methods: {
		isPlaying(video) {
			const isVideoPlaying = !!(video.currentTime > 0 && !video.paused && !video.ended && video.readyState > 2);
			return isVideoPlaying;
		},

		setupListeners() {
			this.video = this.$refs.video;

			this.video.addEventListener("loadeddata", (event) => {
				this.videoDuration = this.formatTime(Math.round(this.video.duration));
				this.$refs.seek.addEventListener('input', this.skipAhead);
			});

			this.video.addEventListener('ended', (e) => {
				this.replay = true;
				this.state = this.videoStates.END;
			});

			this.video.addEventListener('timeupdate', this.updateProgress);
		},

		onReplay() {
			this.video.currentTime = 0;
			this.video.play();
			this.state = this.videoStates.PLAYING;
		},

		onClickVideo(e) {
			if (this.video.paused || this.video.ended) {
				this.video.play();
				this.state = this.videoStates.PLAYING;
			} else {
				this.video.pause();
				this.state = this.videoStates.PAUSE;
			}

			e.preventDefault();
		},

		updateProgress() {
			const currentTime = this.$refs.video.currentTime;
			const duration  = this.$refs.video.duration;
			const progress = currentTime / duration;

			this.videoElapsed = this.formatTime(Math.round(currentTime));
			let seekbar = this.$refs.seek;
			let progressbar = this.$refs.progressbar;

			if(!progress || !seekbar || !progressbar) return;

			seekbar.value = Math.floor(progress * 100);
			progressbar.value = Math.floor(progress * 100);
		},

		formatTime(timeInSeconds) {
			const result = new Date(timeInSeconds * 1000).toISOString().substr(11, 8);
			return {
				minutes: result.substr(3, 2),
				seconds: result.substr(6, 2),
			}
		},

		skipAhead(event) {
			const skipTo = event.target.dataset.seek ? event.target.dataset.seek : event.target.value;
			
			this.video.currentTime = this.$refs.video.duration * (skipTo /100);
			this.$refs.progressbar.value = skipTo;
			this.$refs.seek.value = skipTo;

			if(this.state === this.videoStates.END) {
				this.state = this.videoStates.PAUSE;
			}
		}		
	}
}
</script>

<style lang="scss">
  
.videopart {
	position: relative;
	
	--progress-bg: #F4FFE7;
	--progress-color: #8D8D8D;
	--video-icon-bg: #8D8D8D;
	--video-icon-bg-hover: #8D8D8D;
	--video-icon-color: #FFF;
	--video-icon-size-mb: 50px; 
	--video-icon-size-desktop: 60px; 


	.video--meta {
    position: absolute;
    background: linear-gradient(0deg, rgba(0, 0, 0, 0.75) 0%, rgba(0, 0, 0, 0) 100%);
    height: 100%;
    inset: 0px;
    border-radius: 8px;

    transition: opacity .2s ease-in;

    &.active {
      opacity: 0;
    }

		&:hover {
			// opacity: 1 !important;

			.video--icon-pause {
				opacity: 1 !important;
				}
		}

    .video--meta-items {
      position: absolute;
      bottom: 1rem;
      left: 1rem;
      color: #FFF;
    }

		.video-time {
			font-size: 14px;
			height: 21px;
		}
  }

	.video-icons {
		position: absolute;
		left: 50%;
		top: 50%;
		transform: translateX(-50%) translateY(-50%);
	}

	.video--icon {
		height: var(--video-icon-size-mb);
		width: var(--video-icon-size-mb);


		@include md { 
			width: var(--video-icon-size-desktop);
			height: var(--video-icon-size-desktop);
		}
	}

	.video-icon__main-fill {
		fill: var(--video-icon-color);
	}

	.video-icon__main-stroke {
		stroke: var(--video-icon-color);
	}

	.video--icon-pause {
		opacity: 0;
		transition: opacity .5s ease-in;
	}

	.videopart__inner {
		position: relative;

		.video--icon-pause {
			opacity: 0;
		}
		&:hover {
			.video--icon-pause {
				opacity: 1;
				animation: hide 2s 1 forwards; 
			}
	
			.video--icon {
				scale: 1.1;
				.video-icon__bg {
					fill: var(--video-icon-bg-hover);
					stroke: var(--video-icon-color);
				}
			}
		}		
	}

	@keyframes hide {
		0% {
			// transform: scale(1);
			opacity: 1;
		}
	
		50% {
			// transform: scale(1.1);
			opacity: 1;
		}
	
		100% {
			// transform: scale(1);
			opacity: 0;
		}
	}

	.video-controls {
		
		.video--icon {
			pointer-events: none;
			transition: all .2s ease-in;
		}

		.video-icon__bg {
			fill: var(--video-icon-bg);
			transition: all .2s linear;
		}
	}
}

.videopart__video {
	display: block;
	width: 100%;
	margin: 0 auto;

	max-height: 75vh;

	// fix border on safari
    -webkit-mask-image: -webkit-radial-gradient(white, black);
    -webkit-backface-visibility: hidden;
    -moz-backface-visibility: hidden;
}

.videopart__caption {
	font-family: $font-body;
	font-weight: 400;
	line-height: 21px;
	text-align: center;
}

.knd-center {
	position: absolute;
	top: 50%;
	left: 50%;
	transform: translate(-50%, -50%);	
}

.video-progress {
	position: relative;
	height: 8.4px;
	margin-bottom: 10px;
	transition: all 0.2s ease;
	background-image: linear-gradient(to bottom, rgba(0, 0, 0, 0.3), rgba(0, 0, 0, 0.5));

  }
progress {
	-webkit-appearance: none;
	-moz-appearance: none;
	appearance: none;
	width: 100%;
	height: 12px;
	pointer-events: none;
	position: absolute;
	top: 0;
	transition: all 0.2s ease;
    border: 1px solid #D5DAFF;
    padding: 2px;
  }

  progress::-webkit-progress-value {
    transition: width .5s ease;
	}

  progress::-webkit-progress-bar {
		background-color: var(--progress-bg);
		border-radius: 2px;
  }
  
  progress::-webkit-progress-value {
		background: var(--progress-color);
		border-radius: 2px;
  }
  
  progress::-moz-progress-bar {
		border: 1px solid var(--progress-color);
		background: var(--progress-color);
  }
  
  .seek {
	opacity: 0;
	position: absolute;
	top: 0;
	width: 100%;
	cursor: pointer;
	margin: 0;
	transition: all 0.2s ease;
  }
  
  .seek:hover+.seek-tooltip {
	display: block;
  }
  
  .seek-tooltip {
		display: none;
		position: absolute;
		top: -50px;
		margin-left: -20px;
		font-size: 12px;
		padding: 3px;
		// content: attr(data-title);
		font-weight: bold;
		color: #fff;
		background-color: rgba(0, 0, 0, 0.6);
  }
</style>